<template>
    <div>
        <section
            class="filters-panel filters-panel--border-bottom row filters-panel__row mb-2"
        >
            <div class="col-lg-5 filters-panel__col d-flex d-lg-block">
                <div class="filters-panel-search v2-retailer-orders__search">
                    <label
                        class="filters-panel-search__label"
                        for="filters-panel-search__input"
                        @click="onSearch"
                    ></label>
                    <input
                        id="filters-panel-search__input"
                        v-model="search"
                        type="text"
                        name=""
                        class="app-input filters-panel-search__input"
                        placeholder="Поиск"
                        @keyup.enter="onSearch"
                    />
                    <label
                        v-if="search"
                        class="filters-panel-search__clear"
                        for="filters-panel-search__input"
                        @click="onClearSearch"
                    ></label>
                </div>
                <button
                    type="button"
                    class="cabinet-btn-icon cabinet-btn-icon--default cabinet-btn-icon--filter d-lg-none ml-3"
                    @click="level1mFilter = true"
                ></button>
            </div>
            <div
                v-if="brands.length > 1"
                class="col-lg-2 filters-panel__col d-none d-lg-block"
            >
                <select-picker
                    :current-value="filter.brands.value"
                    :options="brands"
                    key-value="BrandID"
                    key-title="BrandName"
                    select-title="Бренды"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('brands', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <button
                    v-if="!isAllDefaultValues"
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    @click="resetFilters()"
                >
                    Сбросить
                </button>
            </div>
        </section>

        <section class="d-lg-none">
            <div
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': level1mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <div class="h3 mobile-filter__title">
                            Бренд
                            <!-- <span class="mobile-filter__selected-count"></span> -->
                        </div>
                        <button
                            type="button"
                            class="mobile-filter__close-btn"
                            @click="level1mFilter = false"
                        ></button>
                    </div>

                    <ul class="mobile-filter__list">
                        <!-- eslint-disable -->
                        <li
                            v-for="(item, i) in this[
                                filter[level2mFilter].srcName
                            ]"
                            :key="i"
                            class="mobile-filter__list-item"
                        >
                            <label class="custom-checkbox"
                            >{{ item[filter[level2mFilter].srcKeyTitle] }}
                                <input
                                    v-model="filter[level2mFilter].value"
                                    type="checkbox"
                                    :value="
                                        item[filter[level2mFilter].srcKeyVal]
                                    "
                                    @change="onFilterChange(level2mFilter)"
                                />
                                <span class="custom-checkbox__checkmark"></span>
                            </label>
                        </li>
                        <!-- eslint-enable -->
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="level1mFilter = false"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>
        </section>
        <div v-if="loading">Loading...</div>
        <div v-else-if="errors.getOrders">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="tryLoadingOrders"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <div
            v-else-if="!paginatedOrders.length"
            class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
        >
            <img
                v-if="search.length === 0"
                src="/img/icons/empty-goods.svg"
                class="dashboard-empty__img ofi"
            />
            <img
                v-else
                src="/img/icons/empty-search.svg"
                class="dashboard-empty__img dashboard-empty__img--search ofi"
            />
            <div class="dashboard-empty__title pt-5">
                {{
                    search || !isAllDefaultValues
                        ? ' По вашему запросу ничего не найдено.'
                        : 'Тут будут отображаться ваши заказы'
                }}
            </div>
        </div>

        <div v-show="!loading && paginatedOrders.length">
            <section class="cabinet-table-options-wrap mb-0">
                <section
                    class="cabinet-table-options flex flex-align-center justify-content-between"
                >
                    <div>
                        <span class="d-none d-md-inline-block">
                            {{
                                pagination.page * pagination.pageSize +
                                    1 -
                                    pagination.pageSize
                            }}
                            -
                        </span>
                        {{
                            Math.min(
                                pagination.page * pagination.pageSize,
                                pagination.totalRecords
                            )
                        }}

                        из {{ pagination.totalRecords }}
                    </div>

                    <div class="d-none d-md-block">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalRecords"
                            :disable-scroll-top="isMobile"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                </section>
            </section>

            <section class="cabinet-section">
                <order-list-item
                    v-for="order in paginatedOrders"
                    :key="order.OrderID"
                    :order="order"
                />
            </section>

            <section
                class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-md-flex"
            >
                <select-picker
                    :current-value="pagination.pageSize"
                    :options="pageSizes"
                    key-value="id"
                    key-title="title"
                    select-width="80"
                    :classes="['select', 'select--small']"
                    @onChange="onPageSizeChange($event)"
                />

                <table-pagination
                    :current-page="pagination.page"
                    :total-pages="pagination.totalPages"
                    :total-products="pagination.totalRecords"
                    :disable-scroll-top="isMobile"
                    @setPage="onSetPage($event)"
                />
            </section>

            <section
                v-if="pagination.page < pagination.totalPages"
                class="flex flex-column flex-align-center pb-4 d-md-none"
            >
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    :disabled="pagination.page >= pagination.totalPages"
                    @click="updateOrdersList(pagination.page + 1, true)"
                >
                    Загрузить еще
                </button>
            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import OrderListItem from '@/components/Cabinet/Supplier/Orders/OrderListItem'

import onResize from '@/mixins/on-resize'

let pageSizes = [10, 20, 50, 100].map(item => {
    return {
        id: item,
        title: item
    }
})

export default {
    name: 'SupplierOrderList',
    components: {
        SelectPicker,
        TablePagination,
        OrderListItem
    },
    mixins: [onResize],
    data() {
        return {
            search: '',
            filter: {
                brands: {
                    title: 'Бренд',
                    srcName: 'brands', //name of store arr
                    srcKeyVal: 'BrandID',
                    srcKeyTitle: 'BrandName',
                    value: [],
                    apiFilterName: 'brands'
                }
            },
            pageSizes,
            level1mFilter: false,
            level2mFilter: 'brands',
            loading: true
        }
    },
    computed: {
        ...mapState('supplierOrders', [
            'orders',
            'mobileOrders',
            'pagination',
            'errors'
        ]),
        ...mapState('supplierBrand', ['brands']),
        isAllDefaultValues() {
            return (
                Object.keys(this.filter).filter(
                    item => this.filter[item].value.length
                ).length === 0
            )
        },
        paginatedOrders() {
            if (document.documentElement.clientWidth > 767) {
                return this.orders
            }
            return this.mobileOrders
        }
    },
    async mounted() {
        this.setFilters()

        await this.updateOrdersList(1)
    },
    async destroyed() {
        this.clearOrders()
    },
    methods: {
        ...mapMutations('supplierOrders', ['SET_PAGINATION']),
        ...mapActions('supplierOrders', ['getOrders', 'clearOrders']),
        ...mapActions('supplierBrand', ['getBrands']),
        onSelectPickerChange(type, val) {
            this.filter[type].value = val
            this.onFilterChange(type)
        },
        async tryLoadingOrders() {
            this.setFilters()
            await this.updateOrdersList(1)
        },
        async setFilters() {
            await this.getBrands({ has_orders: true })
        },
        setlevel2mFilters(filterKey) {
            this.level2mFilter = filterKey
        },
        resetFilters() {
            Object.keys(this.filter).forEach(item => {
                this.filter[item].value = []
            })
            this.updateOrdersList(1)
            this.closeAllmFilters()
        },
        closeAllmFilters() {
            // this.level2mFilter = false
            this.level1mFilter = false
        },
        onFilterChange(filterType) {
            this.updateOrdersList(1)
        },
        updateOrdersList: _.debounce(async function(
            page = 1,
            isMobilePagination = false
        ) {
            this.loading = true
            this.$Progress.start()

            let data = { page, isMobilePagination }
            Object.keys(this.filter).forEach(item => {
                if (this.filter[item].value.length) {
                    let valuesArr = [...this.filter[item].value]

                    if (!valuesArr.length) {
                        valuesArr = [null]
                    }

                    data[this.filter[item].apiFilterName] = valuesArr
                }
            })

            if (this.search) {
                data.search = this.search
            }

            await this.getOrders(data)
                .catch(() => {
                    this.loading = false
                })
                .then(() => {
                    this.loading = false
                })
        },
        800),
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.updateOrdersList(page)
        },
        onPageSizeChange(val) {
            this.SET_PAGINATION({
                key: 'pageSize',
                val
            })

            this.updateOrdersList(1)
        },
        onSearch() {
            this.$Progress.start()
            this.updateOrdersList(1)
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()
            this.updateOrdersList(1)
        }
    }
}
</script>
